import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {MenuService} from './menu.service';
import {PipesModule} from '../../pipes/pipes.module';
import {RouterModule} from '@angular/router';
import {SideMenuComponent} from './sidemenu.component';

@NgModule({
    declarations: [
        SideMenuComponent,

    ],
    imports: [
        CommonModule,
        PipesModule,
        RouterModule
    ],
    exports: [
        SideMenuComponent,
    ],
    providers: [
        MenuService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SideMenuModule {
}
